"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseResponseBody = exports.parseAirrorResponse = exports.declare = exports.configure = exports.isEndpoint = void 0;
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const utils_1 = require("./utils");
const isEndpoint = (node) => node.method !== undefined &&
    node.path !== undefined;
exports.isEndpoint = isEndpoint;
const config = {
    host: 'localhost:3001',
    fetch: isomorphic_fetch_1.default,
};
const configure = (options) => {
    Object.assign(config, options);
};
exports.configure = configure;
const declare = (properties) => ({
    as: () => Object.assign((_args, _options) => __awaiter(void 0, void 0, void 0, function* () {
        const host = (_options === null || _options === void 0 ? void 0 : _options.host) || config.host;
        const fetch = (_options === null || _options === void 0 ? void 0 : _options.fetch) || config.fetch;
        const { method } = properties;
        const { path, args } = (0, utils_1.parsePath)({ path: properties.path, args: _args });
        const [query, body] = ['get', 'delete'].includes(method)
            ? [`?${(0, utils_1.encodeQueryParams)(args)}`, undefined]
            : ['', args];
        const response = yield fetch(`${host}${path}${query}`, {
            method: method.toUpperCase(),
            body: body && JSON.stringify(body),
            headers: Object.assign(Object.assign({}, ((_options === null || _options === void 0 ? void 0 : _options.headers) || {})), { 'Content-Type': 'application/json' }),
        });
        const responseBody = yield (0, utils_1.parseResponseBody)(response);
        if (!response.ok) {
            return (0, utils_1.parseAirrorResponse)(Object.assign(Object.assign({}, response), { body: responseBody }));
        }
        return responseBody;
    }), properties),
});
exports.declare = declare;
// TODO: Remove this when old sdk is sunsetted
var utils_2 = require("./utils");
Object.defineProperty(exports, "parseAirrorResponse", { enumerable: true, get: function () { return utils_2.parseAirrorResponse; } });
Object.defineProperty(exports, "parseResponseBody", { enumerable: true, get: function () { return utils_2.parseResponseBody; } });
//# sourceMappingURL=index.js.map